import metricsApi from './api';

export default [metricsApi()];
